import { render, staticRenderFns } from "./ShowProducts.vue?vue&type=template&id=4563bd09&scoped=true&"
import script from "./ShowProducts.vue?vue&type=script&lang=js&"
export * from "./ShowProducts.vue?vue&type=script&lang=js&"
import style0 from "./ShowProducts.vue?vue&type=style&index=0&id=4563bd09&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4563bd09",
  null
  
)

export default component.exports